export class MonthlyPresenceDownloadRequest {
    _year = -1;
    _month = -1;
    _companyId = null;
    _constructionId = null;

    constructor(
        year,
        month,
        companyId,
        constructionId
    ) {
        this._year = year;
        this._month = month;
        this._companyId = companyId;
        this._constructionId = constructionId;
    }

    setYear(year) {
        this._year = year;
    }

    setMonth(month) {
        this._month = month;
    }

    setCompanyId(companyId) {
        this._companyId = companyId;
    }

    setConstructionId(constructionId) {
        this._constructionId = constructionId;
    }

    hasConstructionId() {
        return !!this._constructionId;
    }

    body() {
        return {
            criteria: {
                year: this._year,
                month: this._month,
                company_id: this._companyId,
                construction_id: this.hasConstructionId() ? this._constructionId : undefined,
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/my-outsources/presence/monthly/webservices/monthly-presence-download/MonthlyPresenceDownloadRequest.js